import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { StyleSheet, Text, View, ImageBackground } from 'react-native';
import Sidebar from './sidebar';
import MainWeather from './main_weather';
import Loader from './loader';
import { useSelector } from 'react-redux';
export default function DrizzleWeather({weather_data}) {
  const [lat, setLat] = React.useState([]);
  const [long, setLong] = React.useState([]);
  const REACT_APP_API_URL = 'https://api.openweathermap.org/data/2.5';
  const REACT_APP_API_KEY = '5d361ddf57410aae46781a0990a8d7f6';
  const REACT_APP_ICON_URL = 'https://openweathermap.org/img/w';
  const [data, setData] = React.useState([]);
  const [data_loaded, set_data_loaded] = React.useState(false);
  const [runned, set_runned] = React.useState(false);
  var w_data = useSelector(state => state.weather);
  //React.useEffect(() => {
  //  setData(weather_data);
 // })

  //var city_name = useSelector(state => state.counter);
  return (

    <ImageBackground source={{uri: "https://firebasestorage.googleapis.com/v0/b/imagehosting-cb259.appspot.com/o/haze_weather.png?alt=media&token=2c8f3b81-ef80-476f-99e8-8b7e15cc763b"}} style={{ width: "100%", height: "100%", resizeMode: "contain" }}>
      {(typeof w_data.main != 'undefined') ? (
        <ImageBackground source={{uri: "https://firebasestorage.googleapis.com/v0/b/imagehosting-cb259.appspot.com/o/haze_weather.png?alt=media&token=2c8f3b81-ef80-476f-99e8-8b7e15cc763b"}} style={{ width: "100%", height: "100%", resizeMode: "contain" }}>
          
          <MainWeather  />
          <Sidebar />

        </ImageBackground>

      ) : (
        <Loader/>

      )
      }

    </ImageBackground >
  )
}



const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
